<template>
    <el-form
        ref="clientContactForm"
        class="contact-inputs mb-0"
        label-position="top"
        :rules="rules"
        :model="contactLocal"
    >
        <div class="flex-row">
            <el-form-item class="wp-5" prop="forename" :label="$t.__('common.labels.first_name')">
                <el-input v-model="contactLocal.forename"></el-input>
            </el-form-item>
            <el-form-item class="wp-5 ml-4" prop="name" :label="$t.__('common.labels.name')">
                <el-input v-model="contactLocal.name"></el-input>
            </el-form-item>
        </div>

        <el-form-item prop="email" :label="$t.__('common.labels.email_address')">
            <el-input v-model="contactLocal.email"></el-input>
        </el-form-item>

        <el-form-item prop="phone.e164" :label="$t.__('common.labels.phone')">
            <tel-input
                v-model="contactLocal.phone"
                mode="edit"
                class="wp-10 contact-input-tel"
                @change="updatePhone"
            />
        </el-form-item>
        <div class="flex-row flex-right">
            <CompassButton
                :label="$t.__('common.actions.cancel')"
                type="secondary"
                @click="$emit('close')"
            />
            <CompassButton
                :label="$t.__('common.actions.save')"
                type="primary"
                class="ml-3"
                @click="submitForm('clientContactForm', 'submit')"
            />
        </div>
    </el-form>
</template>

<script>
import TelInput from 'vcomponents/inputs/TelInput.vue';
import FormMixin from 'mixins/FormMixins';
import { createNamespacedHelpers } from 'vuex';
const clientCart = createNamespacedHelpers('clientCart');

export default {
    components: {
        TelInput,
    },
    mixins: [FormMixin],
    props: {
        contact: {
            type: Object,
            required: true,
        },
    },
    data() {
        return {
            contactLocal: {},
            rules: {
                name: [{ required: true, message: this.$l10n.__('Veuillez renseigner un nom') }],
                forename: [
                    { required: true, message: this.$l10n.__('Veuillez renseigner un prénom') },
                ],
                'phone.e164': [
                    {
                        required: true,
                        message: this.$l10n.__('Veuillez renseigner un numéro de téléphone'),
                    },
                    {
                        min: 4,
                        message: this.$l10n.__('Veuillez renseigner un numéro de téléphone valide'),
                    },
                ],
                email: [
                    {
                        required: true,
                        type: 'email',
                        message: this.$l10n.__('Veuillez renseigner une adresse email'),
                    },
                ],
            },
        };
    },
    created() {
        this.contactLocal = _.cloneDeep(this.contact);
    },
    methods: {
        ...clientCart.mapActions(['updateContact']),
        submit() {
            this.updateContact(this.contactLocal);
            this.$emit('close');
        },
        updatePhone(value) {
            this.contactLocal.phone = value;
        },
    },
};
</script>

<style lang="scss">
@import '~@sellsy/styleguide/src/_variables';
.contact-inputs {
    .intl-tel-input,
    .intl-tel-input input {
        width: 100%;
    }

    .el-form-item.is-error .contact-input-tel input {
        border: 1px solid $red !important;
        border-radius: 5px;
    }

    .contact-cancel {
        &:hover {
            border-color: $gray-100;
        }
    }
}
</style>
